import {ObserverBase} from "@share/web-conferences/signal-r/observers/ObserverBase";
import {SignalRMethod} from "@api/repositories/reatime-repository/types";
import {ObserverData} from "@share/web-conferences/interfaces/signalr/ObserverData";
import {RecordingStatusUpdate} from "@share/web-conferences/types/RecordingStatusUpdate";
import {RecordingStatuses} from "@share/web-conferences/enums/RecordingStatuses";
import {setRecordingStartedAction} from "@share/web-conferences/store/actions";
import {sendRecordingNotification} from "@share/web-conferences/helpers/recordings/NotificationSender";
import {StoreParameters} from "@share/web-conferences/types/StoreParameters";
import { RecordingController } from "@share/web-conferences/helpers/RecordingController";

export class RecordingStatusObserver extends ObserverBase {
    method = SignalRMethod.webConferenceRecordingUpdate;
    private _shouldReact = false;

    constructor(readonly data: ObserverData, readonly recodingController: RecordingController, shouldReact = false) {
        super(data);
        this._shouldReact = shouldReact;
    }

    setShouldReact(value: boolean) {
        this._shouldReact = value;
    }

    get shouldReact() {
        return this._shouldReact;
    }

    private isStatusStarted(statusUpdate: RecordingStatusUpdate): boolean {
        return statusUpdate.status == RecordingStatuses.Started || statusUpdate.status == RecordingStatuses.InProgress;
    }

    saveIsStarted(statusUpdate: RecordingStatusUpdate)
    {
        this.data.store.dispatch(setRecordingStartedAction, {
            key: this.data.stateKey,
            data: this.isStatusStarted(statusUpdate)
        } as StoreParameters<boolean>);
    }

    async callback(data: any): Promise<void> {
        if (!this._shouldReact) {return;}

        try {
            const recordingStatus = JSON.parse(data) as RecordingStatusUpdate;
            console.log('new recording status', recordingStatus);
            sendRecordingNotification(this.data.store, recordingStatus.status);
            this.saveIsStarted(recordingStatus);
            this.recodingController.isBeingRecorded = this.isStatusStarted(recordingStatus);
        }
        catch (e) {
            this.data.store.dispatch('reportError', e);
            console.error(e);
        }
    }
}
